import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { setTokenStorage } from '../api/auth.ts';
import { onThemeChange } from '../theme/theme.ts';
import { isNativeApp } from './platform.ts';
import { initPush } from './push.ts';
import { loadSecureTokenStorage } from './tokenStorage.ts';

/** prepares the native shell before the app renders; no-op in the browser */
export async function initNativeBeforeRender(): Promise<void> {
  if (!isNativeApp()) return;
  document.documentElement.classList.add('native');
  setTokenStorage(await loadSecureTokenStorage());
  // Style.Dark = light text for the dark theme
  onThemeChange((resolved) => {
    void StatusBar.setStyle({ style: resolved === 'dark' ? Style.Dark : Style.Light }).catch(() => undefined);
  });
}

export async function initNativeAfterRender(navigate: (path: string) => void): Promise<void> {
  if (!isNativeApp()) return;
  await initPush(navigate).catch(() => undefined);
  await SplashScreen.hide().catch(() => undefined);
}
